import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  // form
  targetId: Constants.RegisterHash,
  values: {},
  // model
  locationModel: [],
  deviceTypeModel: []
}

const getters = {
  get: state => state,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        case 'modelNumber':
          if (!value.length) return ''
          return value.filter((item, index, array) => {
            return array.indexOf(item) === index
          }).join('、')
        case 'status':
          return Utility.getConstantsLabel(['Status'], value)
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  /**
   * 初期読出し
   */
  loadModel ({commit}, {targetId, communityParams, locationParams, deviceTypeParams}) {
    commit('setTargetId', targetId)

    return new Promise((resolve, reject) => {
      // データを読出し
      ApiManager.request(
        [
          'community',
          'community',
          'device'
        ],
        [
          'v1CommunityDetailGet',
          'v1LocationListGet',
          'v1DeviceListGet'
        ],
        [
          communityParams,
          locationParams,
          deviceTypeParams
        ])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('inited', res[0].data)
            commit('setLocationModel', res[1].data.locations)
            commit('setDeviceTypeModel', res[2].data.deviceTypes)
            console.log('values', state.values)
            console.log('locationModel', state.locationModel)
            resolve(res[0].data)

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  /**
   * 初期読出し
   */
  loadLocationList ({commit}, {locationParams}) {
    return new Promise((resolve, reject) => {
      // データを読出し
      ApiManager.request(
        ['community'],
        ['v1LocationListGet'],
        [locationParams])
        .then(res => {
          console.log(res)
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setLocationModel', res[0].data.locations)
            console.log('locationModel', state.locationModel)
            resolve(res[0].data)

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  
  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // init
  inited (state, data) {
    Vue.set(state, 'values', data)
  },

  // model
  setLocationModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'locationModel', data)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  },
  setDeviceTypeModel (state, data) {
    Vue.set(state, 'deviceTypeModel', data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
